import React, { PureComponent } from 'react'
import { Provider } from 'react-redux'
import { StoreContext } from 'sb-redux-hook'
import { ConnectedRouter } from 'sb-connected-react-router'
import GlobalsContext from 'sb-hooks/GlobalsContext'

import LanguageProvider from 'containers/LanguageProvider/LanguageProvider'
import ContextProvider from 'containers/ContextProvider/ContextProvider'
import LastLocationContextProvider from 'containers/LastLocationContextProvider/LastLocationContextProvider'


class Root extends PureComponent {

  constructor(props) {
    const { history } = props

    super()

    this.state = {
      pathname: null,
      search: null,
    }

    history.listen(({ pathname, search }) => {
      this.setState({
        pathname,
        search,
      })
    })
  }

  render() {
    const { pathname, search } = this.state
    const { children, store, storeEvents, globals, history, translationMessages } = this.props

    return (
      <Provider store={store}>
        <StoreContext.Provider value={{ store, storeEvents }}>
          <ContextProvider globals={globals}>
            <GlobalsContext.Provider value={{ globals }}>
              <LanguageProvider messages={translationMessages}>
                <ConnectedRouter history={history}>
                  <LastLocationContextProvider
                    pathname={pathname}
                    search={search}
                    location={history.location}
                  >
                    {children}
                  </LastLocationContextProvider>
                </ConnectedRouter>
              </LanguageProvider>
            </GlobalsContext.Provider>
          </ContextProvider>
        </StoreContext.Provider>
      </Provider>
    )
  }
}


export default Root
